import { allComments, allVerticalLines } from './forumElements';

// fce forumVerticalLine projede všechny reakční komentřáře a u jejich vodící vertikálních lines, které se napojují na původní komentař na který reagují, zjistí si jejich offsetTop od vrchu stránky, poté zjistí offsetTop reakčního komentáře a nastavý správnou výšku liny až k ikonce komentáře

export const forumVerticalLine = (): void => {
  allVerticalLines.forEach((verticalLine) => {
    const verticalLineToId = verticalLine.getAttribute('data-comment-vertical-line-to');
    const verticalLineOffsetParentTop = (verticalLine.offsetParent as HTMLElement)?.offsetTop || 0;

    // získání pozice komentáře na který se reaguje
    const targetComment = Array.from(allComments).find(
      (comment) => comment.getAttribute('data-comment-id') === verticalLineToId
    );
    const targetCommentOffsetTop = targetComment ? targetComment.offsetTop : 0;

    // výpočet výšky a top odsazení liny reakčního komentáře
    // výška avatara slouží ke kalibraci správné výšky a posunutí vertikální liny
    const iconAvatarHeight = 50;
    const dateHeight = 13;
    let setHeightToLine =
      verticalLineOffsetParentTop - targetCommentOffsetTop - iconAvatarHeight + dateHeight;
    let setTopToLine = setHeightToLine - iconAvatarHeight / 2 + dateHeight;

    // mobilní zařízení mají jiný layout, proto je potřeba upravit výšku a posunutí liny
    if (window.innerWidth <= 768) {
      setTopToLine += 20;
      setHeightToLine += 20;
    }

    verticalLine.style.height = `${setHeightToLine}px`;
    verticalLine.style.top = `-${setTopToLine}px`;
  });
};
